export enum referencedWalletAccess {
  inflow = "inflow",
  outflow = "outflow",
  InflowOutflow = "inflowOutflow",
}
